import { COLORS } from 'helpers/globals'

export default {
  colorPicker: {
    display: 'flex',
    justifyContent: 'space-evenly',
    width: '100%',
    height: '2rem',
    flex: 1
  },
  color: {
    cursor: 'pointer',
    border: '1px solid #6c6c6c',
    flex: '0 1 2rem',
    display: 'flex',
    borderRadius: '50%',
    '&:hover': { boxShadow: `0 0 3px 1px ${COLORS.secondary}` }
  },
  input: {
    flex: '0 1 20%',
    fontSize: '1.4rem',
    height: 'auto !important'
  },
  checkIcon: {
    margin: 'auto',
    fontSize: '1.2rem'
  },
  noColorIcon: {
    margin: 'auto'
  },
  filler: {
    flex: '0 1 2rem'
  }
}



// WEBPACK FOOTER //
// ./src/components/MarkupDetails/ColorPicker/style.js